'use client';

import * as Styled from './NotFoundPage.styled';
import goatChomp from './assets/goatChomp.json';

import * as Sentry from '@sentry/nextjs';
import Link from 'next/link';
import React, { useEffect } from 'react';

type Props = Readonly<{
  redirectLink?: string;
  linkText?: string;
}>;

export const NotFoundPage = ({ redirectLink, linkText = 'home.' }: Props) => {
  useEffect(() => {
    const err = new Error(`404 Not Found: ${window.location.pathname}`);
    Sentry.setTag('http.status_code', '404');
    Sentry.captureException(err, {
      level: 'error',
      extra: { path: window.location.pathname },
    });
  }, []);

  const finalHomeUrl = redirectLink || window.location.origin;

  return (
    <Styled.Container>
      <Styled.GoatPen>
        <Styled.GoatFood>
          404
          <Styled.LottieContainer animationData={goatChomp} loop={true} />
        </Styled.GoatFood>
      </Styled.GoatPen>
      <h3>Not found?! Someone must have eaten that page.</h3>

      {finalHomeUrl && (
        <Styled.RedirectText>
          Let's goat you back <Link href={finalHomeUrl}>{linkText}</Link>
        </Styled.RedirectText>
      )}
    </Styled.Container>
  );
};
